import * as isNode from 'detect-node';
// const isNode = Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';
export var env = {
    isNode: isNode,
    forceCache: false,
};
